import React from 'react';
import './global.css';
import Routes from './routes';

import { Provider } from 'react-redux';
import { createStore } from 'redux';

import combReducers from './ReducersCombine';

let store = createStore(combReducers);

function App() {
  return (
    <Provider store={store} >
      <Routes />
    </Provider>
  );
}

export default App;
